import { ButtonHTMLAttributes } from 'react';
import { clsx } from 'clsx';
import { SvgArrowLeft } from '@/components/icons';
import s from './ButtonArrow.module.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  transparent?: boolean;
  reverse?: boolean;
}

export const ButtonArrow = ({ className, transparent, reverse, ...props }: Props) => {
  return (
    <button
      className={clsx(s.button, className, {
        [s.button_transparent]: transparent,
        [s.button_reverse]: reverse,
      })}
      {...props}
    >
      <SvgArrowLeft />
    </button>
  );
};